import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import ModernNavbar from "../components/modern-navbar";
import ModernFooter from "../components/modern-footer";

const Pricing = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="modern-landing">
      <ModernNavbar />

      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            <h1>Pricing</h1>
            <p>
              Choose the perfect plan for your business needs. Contact us for
              custom pricing tailored to your requirements.
            </p>
          </div>
        </div>
      </section>

      <section className="pricing-section">
        <div className="container">
          <div className="pricing-grid">
            <div className="pricing-card">
              <h3>Starter</h3>
              <div className="price">Contact Us</div>
              <ul>
                <li>Up to 100 transactions</li>
                <li>Basic reporting</li>
                <li>Email support</li>
                <li>ETIMS integration</li>
              </ul>
              <Link to="/contact" className="btn-primary">
                Get Quote
              </Link>
            </div>
            <div className="pricing-card featured">
              <h3>Professional</h3>
              <div className="price">Contact Us</div>
              <ul>
                <li>Unlimited transactions</li>
                <li>Advanced analytics</li>
                <li>Priority support</li>
                <li>API access</li>
                <li>Custom integrations</li>
              </ul>
              <Link to="/contact" className="btn-primary">
                Get Quote
              </Link>
            </div>
            <div className="pricing-card">
              <h3>Enterprise</h3>
              <div className="price">Contact Us</div>
              <ul>
                <li>Custom solutions</li>
                <li>Dedicated support</li>
                <li>On-premise deployment</li>
                <li>White-label options</li>
                <li>SLA guarantees</li>
              </ul>
              <Link to="/contact" className="btn-primary">
                Get Quote
              </Link>
            </div>
          </div>
        </div>
      </section>

      <ModernFooter />
    </div>
  );
};

export default Pricing;
